var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMySavedItems = function SvgMySavedItems(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-saved-items_svg__igbqwa05fa)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.36 2.853a5.58 5.58 0 00-3.958-1.64 5.58 5.58 0 00-3.958 1.64L10 3.286l-.444-.433a5.581 5.581 0 00-3.958-1.64A5.598 5.598 0 001.64 10.77l7.77 7.772a.83.83 0 001.18 0l7.77-7.77a5.598 5.598 0 000-7.918zm-.589 7.328l-7.77 7.771-7.772-7.771a4.733 4.733 0 01-1.396-3.37c0-1.272.496-2.468 1.396-3.368.9-.9 2.096-1.396 3.369-1.396a4.74 4.74 0 013.377 1.404L10 4.448l1.033-1.005c.9-.9 2.096-1.396 3.37-1.396 1.272 0 2.468.496 3.368 1.396.9.9 1.396 2.096 1.396 3.369a4.733 4.733 0 01-1.396 3.369z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.231 3.059a.33.33 0 01-.463-.001l-.076.21.277.1.174-.089.088-.22z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-saved-items_svg__igbqwa05fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMySavedItems;